import { InputNumber, Form } from 'antd';
import { getMessage, getRules } from './util';

const InputNumberForm = (props) => {
    let { updated, desc, field_type } = props;
    const disabled = updated !== 0;

    return (
        <Form.Item
            key={props.field_id}
            label={props.label === undefined ? props.name : props.label}
            name={props.en_name}
            rules={getRules(props)}
            getValueFromEvent={(value) => {
                if (value?.length) {
                    // 非数字，去掉非数字
                    if (/\D/g.test(value)) {
                        return value.replace(/\D/g, '');
                    }
                    // 多位数字，去掉前导0
                    // if (value.toString()?.startsWith('0')) {
                    //     return value.substring(1); // 去掉第一个字符
                    // }
                }

                return value;
            }}
        >
            <InputNumber
                className={'grt-dynamic-input-number'}
                disabled={disabled}
                style={{ width: '100%' }}
                placeholder={desc || getMessage(field_type)}
            ></InputNumber>
        </Form.Item>
    );
};
export default InputNumberForm;
